module.exports = __webpack_public_path__ + "assets/img/device-status-reports.66e2bedb.svg";